/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './card-background.styles';
import { CardBackgroundColor, CardBackgroundProps } from './types';

export const DEFAULT_TEST_ID = 'card-background';

export { CardBackgroundColor };

const StyledCardBackground = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const CardBackground: FunctionComponent<CardBackgroundProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    children,
    expandOnHover = true,
    tag,
    ...otherProps
}: CardBackgroundProps) => {
    return (
        <StyledCardBackground
            data-testid={dataTestId}
            expandOnHover={expandOnHover}
            tag={tag}
            {...otherProps}
        >
            <div
                className="background"
                data-testid={`${dataTestId}__background`}
            >
                {tag && (
                    <span className="tag" data-testid={`${dataTestId}__tag`}>
                        {tag}
                    </span>
                )}
            </div>
            {children}
        </StyledCardBackground>
    );
};
